import "../css/header.scss";
import React, { useContext, useEffect, useRef, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { CartContext } from "./CartContext";
import { SITE_CONFIG } from "../config/siteConfig";
import { HEADER_POLICY_LINKS } from "../config/policyConfig";

function Header() {
  const [moreOpen, setMoreOpen] = useState(false);
  const menuRef = useRef(null);
  const location = useLocation();
  const { cartItems } = useContext(CartContext);
  const cartCount = cartItems.reduce((total, item) => total + item.quantity, 0);

  useEffect(() => {
    setMoreOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    const closeOnOutsideClick = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMoreOpen(false);
      }
    };
    const closeOnEscape = (event) => {
      if (event.key === "Escape") setMoreOpen(false);
    };
    document.addEventListener("pointerdown", closeOnOutsideClick);
    document.addEventListener("keydown", closeOnEscape);
    return () => {
      document.removeEventListener("pointerdown", closeOnOutsideClick);
      document.removeEventListener("keydown", closeOnEscape);
    };
  }, []);

  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });

  return (
    <header className="site-header">
      <div className="header-top">
        <div className="logo">
          <Link to="/" onClick={toTop} aria-label={`${SITE_CONFIG.brand} home`}>
            <svg className="brand-mark" viewBox="0 0 54 54" aria-hidden="true">
              <path d="M8 42V18L27 7l19 11v24" />
              <path d="M15 39V22l12 8 12-8v17" />
              <circle cx="27" cy="17" r="3" />
            </svg>
            <span className="brand-word">
              <span>{SITE_CONFIG.brand.slice(0, 5)}</span>
              <span>{SITE_CONFIG.brand.slice(5)}</span>
            </span>
          </Link>
        </div>
        <div className="header-icons">
          <Link to="/cartpage" aria-label={`Cart with ${cartCount} items`}>
            <svg fill="none" className="icon icon-cart-empty" viewBox="0 0 40 40" width="44" height="44" aria-hidden="true">
              <path fill="currentColor" fillRule="evenodd" d="M15.75 11.8h-3.16l-.77 11.6a5 5 0 0 0 4.99 5.34h7.38a5 5 0 0 0 4.99-5.33L28.4 11.8zm0 1h-2.22l-.71 10.67a4 4 0 0 0 3.99 4.27h7.38a4 4 0 0 0 4-4.27l-.72-10.67h-2.22v.63a4.75 4.75 0 1 1-9.5 0zm8.5 0h-7.5v.63a3.75 3.75 0 1 0 7.5 0z" />
            </svg>
            {cartCount > 0 && <span className="cart-count">{cartCount}</span>}
          </Link>
        </div>
      </div>
      <nav className="header-nav" aria-label="Primary navigation">
        <ul>
          <li><Link to="/shop">Sale</Link></li>
          <li><Link to="/about">About</Link></li>
          <li><Link to="/contact">Help</Link></li>
          <li className="more-menu" ref={menuRef}>
            <button type="button" onClick={() => setMoreOpen((open) => !open)} aria-expanded={moreOpen} aria-haspopup="true">
              More <span aria-hidden="true">⌄</span>
            </button>
            {moreOpen && (
              <ul className="more-menu__panel">
                {HEADER_POLICY_LINKS.map(([label, path]) => (
                  <li key={path}><Link to={path} onClick={toTop}>{label}</Link></li>
                ))}
              </ul>
            )}
          </li>
        </ul>
      </nav>
    </header>
  );
}

export default Header;
